import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/Home.vue';
import CategoryPage from '../views/Category.vue';
import RankingPage from '../views/Ranking.vue';
import UpdatePage from '../views/Update.vue';
import ComicDetail from '../views/ComicDetail.vue';
import ComicReader from '../views/ComicReader.vue';
import ProfilePage from '../views/Profile.vue';
import AboutPage from '../views/About.vue';
import ContactPage from '../views/Contact.vue';
import AgreementPage from '../views/Agreement.vue';
import PrivacyPage from '../views/Privacy.vue';
import VipSubscribePage from '../views/VipSubscribe.vue';
import CoinRechargePage from '../views/CoinRecharge.vue';
import SubmissionPage from '../views/Submission.vue';
import HelpPage from '../views/Help.vue';
import YouthModePage from '../views/YouthMode.vue';
import CopyrightPage from '../views/Copyright.vue';
import CheckInPage from '../views/CheckIn.vue';
import NotificationsPage from '../views/Notifications.vue';
import AuthorApplicationPage from '../views/AuthorApplication.vue';
import ReadingHistoryPage from '../views/ReadingHistory.vue';
import FavoritesPage from '../views/Favorites.vue';
import MyCommentsPage from '../views/MyComments.vue';
import PurchaseHistoryPage from '../views/PurchaseHistory.vue';
import MinorProtectionPage from '../views/MinorProtection.vue';

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/category', name: 'CategoryPage', component: CategoryPage },
  { path: '/ranking', name: 'RankingPage', component: RankingPage },
  { path: '/update', name: 'UpdatePage', component: UpdatePage },
  { path: '/submission', name: 'SubmissionPage', component: SubmissionPage },
  { path: '/comic/:id', name: 'ComicDetail', component: ComicDetail },
  {
    path: '/reader/:id/:comicId?',
    name: 'ComicReader',
    component: ComicReader,
    props: true // 允许将路由参数作为props传递给组件
  },
  { path: '/profile', name: 'ProfilePage', component: ProfilePage },
  { path: '/checkin', name: 'CheckIn', component: CheckInPage, meta: { requiresAuth: true } },
  { path: '/notifications', name: 'Notifications', component: NotificationsPage, meta: { requiresAuth: true } },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/contact', name: 'Contact', component: ContactPage },
  { path: '/agreement', name: 'Agreement', component: AgreementPage },
  { path: '/privacy', name: 'Privacy', component: PrivacyPage },
  { path: '/minor-protection', name: 'MinorProtection', component: MinorProtectionPage },
  { path: '/copyright', name: 'Copyright', component: CopyrightPage },
  { path: '/vip', name: 'VipSubscribe', component: VipSubscribePage },
  { path: '/coins', name: 'CoinRecharge', component: CoinRechargePage },
  { path: '/help', name: 'Help', component: HelpPage },
  { path: '/youth-mode', name: 'YouthMode', component: YouthModePage, meta: { requiresAuth: true } },
  { path: '/author-application', name: 'AuthorApplication', component: AuthorApplicationPage, meta: { requiresAuth: true } },
  { path: '/reading-history', name: 'ReadingHistory', component: ReadingHistoryPage, meta: { requiresAuth: true } },
  { path: '/favorites', name: 'Favorites', component: FavoritesPage, meta: { requiresAuth: true } },
  { path: '/my-comments', name: 'MyComments', component: MyCommentsPage, meta: { requiresAuth: true } },
  { path: '/purchase-history', name: 'PurchaseHistory', component: PurchaseHistoryPage, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresAuth) {
    const token = localStorage.getItem('userToken');
    if (!token) {
      alert('该功能需要先登录后才能使用，请先登录');
      next({ path: '/profile', query: { redirect: to.fullPath } });
      return;
    }
  }
  next();
});

export default router; 